"use client"
import { useEffect } from "react"
import Lenis from "lenis"

export default function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      autoResize: true,
    });

    (window as any).lenis = lenis;

    function raf(time: number) {
      lenis.raf(time)
      requestAnimationFrame(raf)
    }

    requestAnimationFrame(raf)

    // Optional: Force a refresh after a small delay to ensure content is loaded
    const timeout = setTimeout(() => {
      lenis.resize()
    }, 500)

    return () => {
      lenis.destroy()
      clearTimeout(timeout)
    }
  }, [])

  return null
}
